<template>
    <footer class="bg-[#1B1A1A] overflow-x-hidden relative z-50">
        <div class="container xl:max-w-[1280px] mx-auto py-10 2xl:px-10 sm:px-5 px-3 grid grid-cols-4 lg:grid-cols-6">
            <div
                class="col-span-4 lg:col-span-2 text-center lg:text-left flex flex-col items-center lg:items-start justify-center lg:justify-start gap-4 3xl:gap-6">
                <div>
                    <router-link to="/" class="">
                        <img class=" w-36  3xl:w-52  object-contain"
                            src="../assets/images/logo-footer.png" alt="logo">
                    </router-link>
                </div>
                <p class="lg:max-w-[20rem] xl:max-w-md xl:text-base text-[#BBBBBB]">
                    At Self Ship Label, our team is available 24/7 to address your inquiries and ensure your shipping
                    experience is smooth and efficient.
                </p>
                <div class="flex items-start gap-3">
                    <router-link to="/">
                        <img class="h-9 w-9 sm:h-[10] sm:w-[10] object-contain transform transition-transform duration-300 ease-out hover:scale-110 "
                            src="../assets/images/fb-black.svg" alt="Facebook" />
                    </router-link>
                    <router-link to="/">
                        <img class="h-9 w-9 sm:h-[10] sm:w-[10] object-contain transform transition-transform duration-300 ease-out hover:scale-110 "
                            src="../assets/images/insta-black.svg" alt="Instagram" />
                    </router-link>
                    <!-- <router-link to="/">
                        <img class="h-9 w-9 sm:h-[10] sm:w-[10] object-contain transform transition-transform duration-300 ease-out hover:scale-110 "
                            src="../assets/images/whatsapp-new.svg" alt="WhatsApp" />
                    </router-link> -->
                    <router-link to="/">
                        <img class="h-9 w-9 sm:h-[10] sm:w-[10] object-contain transform transition-transform duration-300 ease-out hover:scale-110 "
                            src="../assets/images/twitter-black.svg" alt="Twitter" />
                    </router-link>
                </div>

            </div>
            <div
                class="col-span-4 grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4 xl:gap-0 md:px-4 xl:px-0 mt-10 sm:mt-0">
                <div class="flex flex-col justify-start gap-2 md:gap-6">
                    <h4 class="font-semibold text-base xl:text-[1.2rem] text-white">Company</h4>
                    <div class="text-[#BBBBBB] flex flex-col gap-2 text-sm md:text-base">
                        <p> <router-link class="transition-all duration-200 hover:font-semibold" to="/about">About
                                us</router-link></p>
                        <p> <router-link class="transition-all duration-200 hover:font-semibold"
                                to="/contact-us">Contact us</router-link></p>
                        <!-- <p> <router-link to="/">Testimonial</router-link></p> -->
                    </div>
                </div>
                <div class="flex flex-col justify-start gap-2 md:gap-6">
                    <h4 class="font-semibold text-base xl:text-[1.2rem] text-white">Product</h4>
                    <div class="text-[#BBBBBB] flex flex-col gap-2 text-sm md:text-base">
                        <p><router-link class="transition-all duration-200 hover:font-semibold"
                                to="/calculator">Calculator</router-link></p>
                        <p><router-link class="transition-all duration-200 hover:font-semibold"
                                to="/faq">FAQs</router-link></p>
                    </div>
                </div>
                <div class="flex flex-col justify-start gap-2 md:gap-6">
                    <h4 class="font-semibold text-base xl:text-[1.2rem] text-white">Resources</h4>
                    <div class="text-[#BBBBBB] flex flex-col gap-2 text-sm md:text-base">
                        <p><router-link class="transition-all duration-200 hover:font-semibold"
                                to="/shipping-restrictions">Shipping Restrictions</router-link></p>
                        <p><router-link class="transition-all duration-200 hover:font-semibold"
                                to="/terms-and-conditions">Terms & Conditions</router-link></p>
                    </div>
                </div>
                <div class="flex flex-col justify-start gap-2 md:gap-6">
                    <h4 class="font-semibold text-base xl:text-[1.2rem] text-white">Contact us</h4>
                    <div class="text-[#BBBBBB] text-sm md:text-base flex flex-col gap-2">
                        <a href="tel:+1 (657) 210-1801">
                            <p class="flex items-center gap-1 xl:gap-3"><img src="../assets/images/phone-white.svg"
                                    alt=""><span class="transition-all duration-200 hover:font-semibold">+1 (657)
                                    210-1801</span></p>
                        </a>
                        <a href="mailto:info@selfshiplabel.com">
                            <p class="flex items-center gap-1 xl:gap-3"><img src="../assets/images/mail-white.svg"
                                    alt=""><span
                                    class="transition-all duration-200 hover:font-semibold">info@selfshiplabel.com</span>
                            </p>
                        </a>
                        <a href="#" target="_blank">
                            <p class="flex items-start gap-1 xl:gap-3"><img src="../assets/images/address-white.svg"
                                    alt=""><span class="transition-all duration-200 hover:font-semibold">Anaheim,
                                    California, United States.</span></p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>


<script>
export default {
    name: "FooterComponent",
    data() {
        return {
            latestYear: new Date().getFullYear().toString(),
        };
    },
};
</script>
